import axios from './axios';

export default async function getStudySiteNames(
  studyName: string
): Promise<string[]> {
  const response = await axios.get(`/study/${studyName}/sites`);
  const { sites } = response.data;
  return sites;
}
